import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import Login from "@/Login/ui/Login.vue";
import TeamSelection from "@/TeamSelection/ui/TeamSelection.vue";
import TruckSelection from "@/TruckSelection/ui/TruckSelection.vue";
import Start from "@/Start/ui/Start.vue";
import Settings from "@/Settings/ui/Settings.vue";
import Shift from "@/Shift/ui/Shift.vue";
import Case from "@/Case/ui/Case.vue";
import Security from "@/Security/ui/Security.vue";
import ChangePassword from "@/ChangePassword/ui/ChangePassword.vue";
import CaseFeedbackSettings from "@/CaseFeedback/ui/CaseFeedbackSettings.vue";
import ProtocolFrame from "@/Protocol/ProtocolFrame.vue";

import { isLoggedIn } from "@/App/middlewares";

if (!process || process.env.NODE_ENV !== "test") {
  Vue.use(VueRouter);
}

const routes: Array<RouteConfig> = [
  {
    path: "/team-selection",
    name: "team-selection",
    component: TeamSelection,
  },
  {
    path: "/truck-selection",
    name: "truck-selection",
    component: TruckSelection,
  },
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/start",
    name: "start",
    component: Start,
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
  },
  {
    path: "/shift",
    name: "shift",
    component: Shift,
  },
  {
    path: "/case",
    name: "case",
    component: Case,
  },
  {
    path: "/security",
    name: "security",
    component: Security,
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: ChangePassword,
  },
  {
    path: "/caseFeedbackSettings",
    name: "caseFeedbackSettings",
    component: CaseFeedbackSettings,
  },
  {
    path: "/protocol",
    name: "protocol",
    component: ProtocolFrame,
  },
];

if (window.electron) {
  routes.push({
    path: "/gpsSource",
    name: "gpsSource",
    component: () => import("@/GpsSource/ui/GpsSource.vue"),
  });
}

const router = new VueRouter({
  mode: window.electron ? "hash" : "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(isLoggedIn);

export default router;
